export enum TransferSteps {
  TRANSFER_INIT = 1,
  TRANSFER_BALANCE,
  TRANSFER_NETWORK,
  TRANSFER_SUCCESS
}

export enum EarnBetTransfer {
  isEarnBetTransfer,
  isNotEarnBetTransfer
}
